import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import {
  BidlineGuard,
  LoginRouteGuard,
  MainGuard,
  RegistrationGuard,
} from './shared/utilities/RouteGuard';

const routes: Routes = [
  { path: '', pathMatch: 'full', redirectTo: 'login' },
  {
    path: 'login',
    canActivate: [LoginRouteGuard],
    loadChildren: () =>
      import('./modules/login/login.module').then((m) => m.LoginModule),
  },
  {
    path: 'home',
    canActivate: [MainGuard],
    loadChildren: () =>
      import('./modules/home/home.module').then((m) => m.HomeModule),
  },
  {
    path: 'registration',
    canActivate: [RegistrationGuard],
    loadChildren: () =>
      import('./modules/user-registration/user-registration.module').then(
        (m) => m.UserRegistrationModule
      ),
  },
  {
    path: 'bidline',
    canActivate: [BidlineGuard],
    loadChildren: () =>
      import('./modules/bidlineview/bidlineview.module').then(
        (m) => m.BidlineviewModule
      ),
  },
  {
    path: '**',
    canActivate: [LoginRouteGuard],
    loadChildren: () =>
      import('./modules/login/login.module').then((m) => m.LoginModule),
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
